// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

label {
  font-family: "Open Sans", sans-serif;
}

::ng-deep#page-wrapper {
  padding-bottom: 60px;
}

::ng-deep#wrapper {
  overflow-x: initial;
}

::ng-deep.wrapper-content {
  position: relative;
}

::ng-deep.clarify-is .mainnav {
  display: flex;
  flex-wrap: wrap;
  margin: 30px 0 40px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav {
    margin: 10px 0 30px;
  }
}
::ng-deep.clarify-is .mainnav.mainnav--bottom {
  margin: 30px 0 40px;
}
::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
  padding: 12px 30px;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  font-size: 16px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav.mainnav--bottom ul li a {
    padding: 9px;
    font-size: 11px;
  }
}
::ng-deep.clarify-is .mainnav.mainnav--bottom ul li.active a {
  background-color: #bbb !important;
  border-top: 1px solid #bbb !important;
  border-bottom: 1px solid #bbb !important;
  border-left: 1px solid #bbb !important;
}
::ng-deep.clarify-is .mainnav--editmode {
  margin: 0 0 15px;
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list {
  flex: 1;
  border-radius: 5px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .mainnav--editmode .mainnav__list {
    flex: none;
    width: 100%;
  }
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list li {
  width: 100%;
  flex: 1;
}
::ng-deep.clarify-is .mainnav--editmode .mainnav__list li a {
  width: 100%;
  padding: 5px 2px;
  text-align: center;
}
::ng-deep.clarify-is .info {
  color: #fff;
  border: 1px solid rgb(0, 173, 208);
  margin-bottom: 18px;
  padding: 20px 40px;
  border-radius: 6px;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .info.infotitle {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info h1 {
  font-size: 36px;
  font-weight: 500;
  margin: 0;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info h1 {
    font-size: 28px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h1 {
    font-size: 24px;
  }
}
::ng-deep.clarify-is .info h1 .info__maintitle {
  margin-right: auto;
}
::ng-deep.clarify-is .info h1 small {
  color: #fff;
  font-size: 80%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h1 small {
    width: 100%;
    margin-top: 5px;
  }
}
::ng-deep.clarify-is .info .card__toprow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
}
::ng-deep.clarify-is .info .card__toprow--tne .card__topcol:first-child {
  width: 72% !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow--tne .card__topcol:first-child {
    flex: 1;
    width: auto !important;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol {
  padding: 0 15px;
  width: 33.3333333333%;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--full {
  width: 100% !important;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol:nth-child(1) {
  width: 28%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol:nth-child(1) {
    flex: 1;
    margin-right: auto;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--tab {
  width: 44%;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol--tab {
    width: 120px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--tt {
  width: 28%;
  margin-left: auto;
  text-align: right;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol--tt {
    width: auto;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul {
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  padding: 0;
  border-radius: 3px;
  line-height: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button svg {
  right: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:first-child button span.card__topcount {
    left: -30px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button svg {
  left: calc(100% + 1px);
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:last-child button span.card__topcount {
    right: -30px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:not(:first-child) {
  margin-left: -1px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li:only-child button {
  border-radius: 3px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button {
  color: rgb(0, 173, 208);
  border: 1px solid rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topactive button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button {
  opacity: 0.2;
  border: 1px solid rgb(0, 173, 208);
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li.card__topcomplete button span.card__topcount.redConverge_count {
  background-color: #EC2121;
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
  position: relative;
  color: rgb(105, 190, 40);
  font-size: 17px;
  padding: 6px 16px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: inline-block;
  height: 100%;
  border: 0;
  background-color: transparent;
  transition: all ease 0.3s;
  appearance: none;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg {
  position: absolute;
  top: -1px;
  height: calc(100% + 2px);
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button svg .st0 {
  fill: rgb(0, 173, 208);
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button {
    padding: 4px 6px;
    font-size: 13px;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:focus {
  outline: none;
  box-shadow: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topdesktext {
    display: none;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
  display: none;
}
@media only screen and (max-width: 1180px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > .card__topmobiletext {
    display: inline-block;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
  width: 16px;
  height: 16px;
  line-height: 16px;
  display: inline-block;
  text-align: center;
  font-size: 0.5em;
  background-color: rgb(0, 173, 208);
  color: #fff;
  margin-left: 4px;
  border-radius: 50%;
  vertical-align: bottom;
  position: relative;
  top: -1px;
}
@media only screen and (max-width: 630px) {
  ::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button > span.card__topcount {
    position: absolute;
    top: auto;
    bottom: -2px;
    right: 0;
    margin: 0;
  }
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover {
  color: rgb(0, 173, 208);
  opacity: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol.card__topcol--tab ul li button:hover > span.card__topcount {
  color: rgb(0, 173, 208);
  background-color: #efefef;
  opacity: 1;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt {
  position: relative;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li .card-body__tooltip {
  display: none;
  position: absolute;
  background: #fff;
  color: #676a6c;
  padding: 5px;
  top: -27px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li button:hover {
  opacity: 0.2 !important;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li:hover .card-body__tooltip, ::ng-deep.clarify-is .info .card__toprow .card__topcol--ctt ul li:active .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .info .card__toprow .card__topcol span.flagicon {
  position: relative;
  right: -6px;
  top: -11px;
  color: #ff0000;
  margin-left: 0;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button {
  border: 1px solid rgb(0, 173, 208);
  background-color: transparent;
  padding: 2px 26px;
  border-radius: 3px;
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  color: rgb(0, 173, 208);
  font-size: 22px;
  line-height: 1.2;
  transition: all ease 0.3s;
  cursor: pointer;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button:hover {
  background-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .info .card__toprow .card__h3button:focus {
  outline: none;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon {
  cursor: pointer;
  position: relative;
  font-size: 18px;
  display: inline-block;
  text-align: right;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon i {
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon:hover > i > .tooltiptext {
  visibility: visible;
}
::ng-deep.clarify-is .info .card__toprow .tooltipicon .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: #fff;
  color: rgb(0, 173, 208);
  text-align: center;
  border-radius: 6px;
  padding: 10px;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);
  font-size: 13px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 1;
}
::ng-deep.clarify-is .info h3 {
  font-size: 20px;
  margin: 0;
  cursor: pointer;
  color: rgb(0, 173, 208);
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .info h3 {
    font-size: 16px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 {
    font-size: 15px;
    word-break: break-word;
  }
}
::ng-deep.clarify-is .info h3 > *:not(:last-child) {
  margin-right: 5px;
}
::ng-deep.clarify-is .info h3 .card__bwnh3pencil a {
  color: rgb(0, 173, 208);
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 .card__bwnh3button {
    width: 100%;
    margin-top: 10px;
  }
}
::ng-deep.clarify-is .info h3 .card__bwnh3button button {
  font-size: 18px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .info h3 .card__bwnh3button button {
    font-size: 16px !important;
  }
}
::ng-deep.clarify-is .info h3 i {
  cursor: pointer;
  font-size: 0.9em;
}
::ng-deep.clarify-is .info h3 i + div {
  padding-left: 7px;
}
::ng-deep.clarify-is .info h3 i + div span {
  display: block;
  font-size: 0.7em;
}
::ng-deep.clarify-is .info h3 i + span {
  padding-left: 7px;
}
::ng-deep.clarify-is app-clarify-data,
::ng-deep.clarify-is app-clarify-sub-challenge {
  display: block;
  margin-top: 30px;
}
::ng-deep.clarify-is .card-default {
  border-radius: 6px;
  border-top-width: 3px;
  border: 0;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}
::ng-deep.clarify-is .card-default.card-default--summary {
  box-shadow: none;
}
::ng-deep.clarify-is .card-default.card-default--summary .info {
  border-top: 0;
  border-right: 0;
  border-left: 0;
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.clarify-is .card-default.card-default--summary .card-body {
  border-right: 0;
  border-bottom: 0;
  border-left: 0;
  border-radius: 0;
}
::ng-deep.clarify-is .card-default.card-default--summary .card-body__inner {
  padding-right: 20px;
  padding-left: 20px;
}
::ng-deep.clarify-is .card-default.card-default--summary + div {
  margin-top: 20px;
}
::ng-deep.clarify-is .card-default + div {
  margin-top: 30px;
}
::ng-deep.clarify-is .card-default .info {
  margin: 0;
  border: 1px solid rgb(0, 173, 208);
  border-radius: 6px;
}
::ng-deep.clarify-is .card-default .info.card__headactive {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol h3 {
  color: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button {
  border-color: #fff;
  background-color: #fff;
  cursor: pointer;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button span {
  color: rgb(0, 173, 208);
  background-color: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc .card__topcol ul li button .st0 {
  fill: #fff;
}
::ng-deep.clarify-is .card-default .info.card__headactive.card__headactive--cc i {
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__inner {
  padding: 15px 40px;
  overflow-y: auto;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body__inner {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .card-default .card-body {
  display: none;
  border: 1px solid #CFDBE2;
  border-top: 0;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
::ng-deep.clarify-is .card-default .card-body.card-show {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body.card-show__wbg {
  background-color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__finalstate p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__finalstate p {
    font-size: 13px;
  }
}
::ng-deep.clarify-is .card-default .card-body__finalstate p:last-child {
  margin-bottom: 0;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--2 {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--2 > div {
  width: 50%;
  padding: 0 10px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__finalstate--2 > div {
    width: 100%;
  }
}
::ng-deep.clarify-is .card-default .card-body__finalstate--list p {
  position: relative;
  padding-left: 10px;
}
::ng-deep.clarify-is .card-default .card-body__finalstate--list p::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #444;
}
::ng-deep.clarify-is .card-default .card-body__subtitle {
  padding-left: 35px;
  margin-bottom: 16px;
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__subtitle--pl0 {
  padding-left: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle *:last-child {
  margin-bottom: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle > span {
  position: absolute;
  top: 0;
  right: 2px;
  opacity: 0.7;
  cursor: pointer;
}
::ng-deep.clarify-is .card-default .card-body__subtitle > span.eyebtn {
  right: 0;
}
::ng-deep.clarify-is .card-default .card-body__subtitle p {
  color: #969798;
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__subtitle p i {
  padding-left: 5px;
}
::ng-deep.clarify-is .card-default .c-radio label {
  padding-left: 0;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .c-radio label > i {
  position: relative;
  top: 2px;
  margin-right: 6px;
  opacity: 0.6;
}
::ng-deep.clarify-is .card-default .c-radio label > span {
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .c-radio input {
  opacity: 0;
  margin: 0;
  display: none;
}
::ng-deep.clarify-is .card-default .c-radio input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .c-radio input + span::before {
  position: absolute;
  color: rgb(0, 173, 208);
  opacity: 0;
  font-size: 11px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.clarify-is .card-default .c-radio input:checked + span {
  border-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .c-radio input:checked + span::before {
  opacity: 1;
}
::ng-deep.clarify-is .card-default .checkbox label {
  min-height: 20px;
  padding-left: 0;
  margin-bottom: 0;
  font-weight: 400;
  cursor: pointer;
  width: 100% !important;
  font-size: 15px;
  font-weight: bold;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .checkbox label > i {
  position: relative;
  top: 1px;
  margin-right: 6px;
}
::ng-deep.clarify-is .card-default .checkbox label > span {
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .checkbox input {
  opacity: 0;
  position: absolute;
  display: none;
}
::ng-deep.clarify-is .card-default .checkbox input + span {
  position: relative;
  display: inline-block;
  vertical-align: top;
  width: 20px;
  height: 20px;
  border-radius: 2px;
  border: 1px solid #ccc;
  margin-right: 10px;
  text-align: center;
  vertical-align: middle;
}
::ng-deep.clarify-is .card-default .checkbox input + span::before {
  font-size: 12px;
  position: absolute;
  color: #fff;
  opacity: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
::ng-deep.clarify-is .card-default .checkbox input:checked + span {
  border-color: #5D9CEC;
  background-color: #5D9CEC;
}
::ng-deep.clarify-is .card-default .checkbox input:checked + span::before {
  opacity: 1;
}
::ng-deep.clarify-is .card-default .card-body__button {
  background-color: #f5f5f5;
  border-top: 1px solid #e3e3e3;
  padding: 12px 40px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn + .btn {
  margin-left: 15px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .float-right {
  margin-left: auto;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-clarify {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-clarify:hover {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-cancel {
  padding: 0;
  margin-left: 25px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-danger {
  background-color: #fff;
  border-color: #fff;
  color: #ef6272;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-danger:hover {
  background-color: #ED2D2D;
  border-color: #EC2121;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-warning em {
  margin: 0;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover {
  background-color: #fff;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall:hover i {
  margin-right: 6px;
}
::ng-deep.clarify-is .card-default .card-body__button .card-button .btn-deleteall i {
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn {
  margin-top: 15px;
  padding: 15px 40px;
  border-top: 1px solid #CFDBE2;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn {
    padding: 12px 20px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow {
  margin: 0 -8px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
  padding: 0 8px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div {
    width: 100%;
    text-align: center;
  }
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div + div {
    margin-top: 10px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow > div.card-body--col--last {
  margin-left: auto;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
  padding: 7px 16px;
  text-align: center;
  transition: all ease 0.3s;
}
@media only screen and (max-width: 991px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn {
    font-size: 12px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn-bottom--disable {
  opacity: 0.5;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn i,
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn em {
  margin-right: 6px;
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--save {
  background-color: rgb(105, 190, 40);
  color: #fff;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--clarify {
  background-color: rgb(0, 173, 208);
  color: #fff;
  border-color: rgb(0, 173, 208);
  font-weight: 900;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel {
  padding: 0;
  background-color: transparent;
  margin-left: 0;
  color: #676a6c;
  border: 0;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--cancel:hover {
  transition: all ease 0.3s;
  color: #000;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--tracking {
  background-color: #6d6e71;
  color: #fff;
  border-color: #6d6e71;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--converge {
  padding: 0 8px;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
  border: 0;
  background-color: transparent;
  position: relative;
  overflow: hidden;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  cursor: pointer;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  font-size: 14px;
  color: #676a6c;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall span {
  position: absolute;
  left: 110%;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
  background-color: #f5f5f5;
  color: #ed5562;
  padding-right: 16px;
  padding-left: 16px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover {
    padding-right: 7px;
    padding-left: 7px;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover > span {
  position: relative;
  left: 0;
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall:hover i {
  margin-right: 6px;
  color: #ed5562;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    background-color: #f5f5f5;
    color: #ed5562;
    padding-right: 16px;
    padding-left: 16px;
  }
}
@media only screen and (max-width: 767px) and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall {
    padding-right: 7px;
    padding-left: 7px;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall > span {
    position: relative;
    left: 0;
  }
  ::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
    margin-right: 6px !important;
  }
}
::ng-deep.clarify-is .card-default .card-body--ebtn .card-body--ebtnrow .btn--deleteall i {
  margin-right: 0;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .note-3 {
  margin-bottom: 15px;
}
::ng-deep.clarify-is .card-default .note-3 label {
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .footer-line {
  color: rgb(0, 173, 208);
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs {
  width: 100%;
  margin-right: 0;
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs input,
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs select,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs input,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs select {
  height: 45px;
  padding: 5px 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__minus--hide,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__minus--hide {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.clarify-is .card-default .card-body__edit .breakthrough-input-tabs .card-body__editinput--ce input,
::ng-deep.clarify-is .card-default .card-body__edit .datadump-input-tabs .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow {
  margin: 0 -15px;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div {
  padding: 0 15px;
  width: 100%;
  margin-bottom: 15px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div:first-child {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol.hideblk {
  display: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div.card-body__editcol--2 {
  width: 50%;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow > div > div {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select {
  appearance: none;
  background-image: url("https://assets.foursightonline.com/app/images/select.png");
  background-size: 10px;
  background-position: right 10px center;
  background-repeat: no-repeat;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:hover, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:focus, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow select:active {
  outline: none;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs {
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editlabel,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editlabel {
  width: 35px;
  padding-right: 15px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-weight: 700;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber {
  width: 40px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: 0;
  border-radius: 4px 0 0 4px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber + .card-body__editinput,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber + .card-body__editinput {
  width: calc(100% - 41px);
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editnumber label,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editnumber label {
  margin-bottom: 0;
  font-weight: 900;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editselect,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
  width: 315px;
  padding-right: 15px;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editselect,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editselect {
    width: 100%;
    padding-right: 0;
    margin-bottom: 10px;
  }
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
  width: calc(100% - 351px);
  padding-right: 60px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input {
  padding-right: 70px;
  font-family: "Open Sans";
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:hover, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:focus, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput input:active,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:hover,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:focus,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput input:active {
  outline: none;
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput {
    width: 100%;
  }
}
@media only screen and (max-width: 767px) {
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput .input-group-text,
  ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput .input-group-text {
    top: auto;
    transform: translate(0);
    bottom: 9px;
  }
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce {
  position: relative;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 7px;
  font-size: 26px;
  color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip, ::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:hover > .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon:active > .card-body__tooltip {
  display: block;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce .converge-icon .card-body__tooltip {
  display: none;
  font-size: 16px;
  color: #676a6c;
  position: absolute;
  bottom: 100%;
  left: 0;
  background: #fff;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  width: max-content;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput--ce input,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput--ce input {
  padding-left: 26px;
}
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .datadump-input-tabs > .card-body__editinput:only-child,
::ng-deep.clarify-is .card-default .card-body__edit .card-body__editrow .breakthrough-input-tabs > .card-body__editinput:only-child {
  width: 100%;
}
::ng-deep.clarify-is .card-default .card-body__edit + .card-body__addnew button {
  margin: 0 36px;
  font-size: 14px;
  font-weight: bold;
  background-color: transparent;
  border: 1px solid transparent;
  padding-right: 0;
  padding-left: 0;
  color: #676a6c;
  transition: all ease 0.3s;
  font-weight: 900;
}
::ng-deep.clarify-is .card-default .card-body__edit + .card-body__addnew button:hover {
  background-color: rgb(0, 173, 208);
  border: 1px solid rgb(0, 173, 208);
  color: #fff;
  padding-right: 12px;
  padding-left: 12px;
}
::ng-deep.clarify-is .card-default .input-tabs {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0 0 0 0;
  margin: 0;
}
::ng-deep.clarify-is .card-default .input-tabs + i {
  position: relative;
  top: -1px;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs {
  position: relative;
  border-bottom: 1px solid #e4e4e4;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::before, ::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::after {
  content: "";
  position: absolute;
  bottom: -1px;
  right: 100%;
  width: 40px;
  height: 1px;
  background-color: #e4e4e4;
}
::ng-deep.clarify-is .card-default .input-tabs.card__body--cs::after {
  right: auto;
  left: 100%;
}
::ng-deep.clarify-is .card-default .input-tabs .select_faded {
  opacity: 0.2;
  padding-left: 32px;
}
::ng-deep.clarify-is .card-default .input-tabs input,
::ng-deep.clarify-is .card-default .input-tabs select {
  height: 45px;
  padding: 9px 15px;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  margin: 7px 0px;
}
::ng-deep.clarify-is .card-default .input-tabs label {
  width: 20px;
  margin: 0;
}
::ng-deep.clarify-is .card-default .input-tabs select {
  width: 9%;
}
::ng-deep.clarify-is .card-default .input-tabs input {
  width: 90%;
  margin-left: 15px;
}
::ng-deep.clarify-is .card-default .input-group-text {
  cursor: pointer;
  padding: 3px 16px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.528571429;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #E9ECEF;
  border: 1px solid #DDE6E9;
  border-radius: 0.25rem;
  position: absolute;
  top: calc(50% + 1px);
  right: 0;
  transform: translateY(-50%);
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-default .input-group-text:hover {
  background-color: rgb(0, 173, 208);
  border-color: rgb(0, 173, 208);
  color: #fff;
}
::ng-deep.clarify-is .card-bottom-button .button {
  font-size: 13px;
  color: #fff;
  padding: 8px 10px;
  border-radius: 3px;
  transition: all ease 0.3s;
}
::ng-deep.clarify-is .card-bottom-button .button:hover {
  opacity: 0.8;
}
::ng-deep.clarify-is .card-bottom-button .button i {
  font-size: 0.8em;
}
::ng-deep.clarify-is .card-bottom-button .button.btn-clarify {
  background-color: rgb(0, 173, 208);
}
::ng-deep.clarify-is .card-bottom-button .button.btn-ideate {
  background-color: rgb(255, 121, 0);
}
::ng-deep.clarify-is .card-bottom-button .button.btn-implement {
  background-color: rgb(245, 67, 89);
}
::ng-deep.clarify-is .datadump-content-tabs {
  display: flex;
  flex-wrap: wrap;
  counter-reset: section;
}
::ng-deep.clarify-is .dump-tabs:first-child {
  display: none;
}
::ng-deep.clarify-is .dump-tabs {
  width: calc(50% - 50px) !important;
}
::ng-deep.clarify-is .datadump__col {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 17px;
}
::ng-deep.clarify-is .datadump__col .datadump-main {
  width: calc(100% - 68px);
  display: inline-block;
  margin-right: 20px;
}
::ng-deep.clarify-is .datadump__col .datadump-main .datadump-group {
  width: 100%;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
::ng-deep.clarify-is .datadump__col .datadump-main .datadump-group input {
  margin-bottom: 0px;
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 0 0.25rem 0.25rem 0;
}

.prevnext {
  padding: 20px 0;
}
.prevnext__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 0;
  margin: 0;
}
.prevnext li {
  list-style: none;
}
.prevnext li.prevnext__next {
  margin-left: auto;
}
.prevnext li.prevnext__prev a:hover > i {
  left: -5px;
}
.prevnext li.prevnext__next a {
  background-color: rgb(0, 173, 208);
  color: #fff;
  opacity: 1;
  padding: 6px 12px;
  border-radius: 3px;
}
.prevnext li.prevnext__next a:hover > i {
  left: 3px;
}
.prevnext li a {
  font-family: "Museo-700" !important;
  font-weight: normal !important;
  font-size: 14px;
  color: #676a6c;
  opacity: 0.47;
  padding: 6px 0;
  display: inline-block;
  transition: all ease 0.3s;
}
.prevnext li a i {
  position: relative;
  font-size: 1.1em;
  left: 0;
  transition: all ease 0.3s;
}

.playbtn {
  position: absolute;
  right: 10px;
  bottom: 7px;
  color: #06a6ce;
}

.Del-data-btn {
  padding: 40px 0;
}
.Del-data-btn .btn {
  margin-left: 15px;
  background-color: #fff;
  border-color: #f5f5f5;
  color: #ff485c;
}
.Del-data-btn .cancelbtn {
  color: #676a6c;
  text-align: center;
  font-size: 15px;
  font-family: "Open Sans", sans-serif;
  line-height: 1.5;
  padding: 6px;
}

.editmode__listrow {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 15px;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow {
    grid-template-columns: 1fr;
  }
}
.editmode__listrow--equalblocks {
  display: flex;
  flex-wrap: wrap;
}
.editmode__listrow--equalblocks > .editmode__listcol {
  flex: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listrow--equalblocks > .editmode__listcol {
    flex: none;
    width: 100%;
  }
}
.editmode__listrow--fullblocks {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid1 {
  grid-template-columns: 1fr;
}
.editmode__listrow--grid3 > div:nth-child(1) {
  grid-row: 1/3;
}
.editmode__listrow--grid4 > div:nth-child(1) {
  grid-row: 1/4;
}
.editmode__listrow--grid5 > div:nth-child(1) {
  grid-row: 1/5;
}
.editmode__listrow--grid6 > div:nth-child(1) {
  grid-row: 1/6;
}
.editmode__listrow--grid7 > div:nth-child(1) {
  grid-row: 1/7;
}
.editmode__listcell {
  padding: 10px 15px;
  background-color: #EBEBEB;
  border: 1px solid #CFDBE2;
  border-radius: 6px;
  height: 100%;
}
.editmode__listcell--startbtn {
  border: 1px solid rgb(0, 173, 208);
  color: rgb(0, 173, 208);
  font-weight: 600;
  font-family: "Open Sans";
  font-size: 16px;
  cursor: pointer;
  line-height: 1;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell {
    font-size: 13px;
  }
}
.editmode__listcell h3 {
  color: rgb(0, 173, 208);
  margin-bottom: 5px;
}
.editmode__listcell h3 a,
.editmode__listcell h3 i {
  color: inherit;
}
.editmode__listcell p {
  font-size: 15px;
  font-weight: 600;
}
@media only screen and (max-width: 767px) {
  .editmode__listcell p {
    font-size: 13px;
  }
}
.editmode__listcell p:last-child {
  margin-bottom: 0;
}

.container-fluid {
  position: relative;
}
.container-fluid .trackInfo {
  padding: 2px 16px;
  background-color: #6d6e71;
  color: #fff;
  margin-left: 40px;
  border-radius: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  font-size: 10px;
}
.container-fluid .trackInfo--clr {
  color: transparent !important;
}
.container-fluid .trackInfo--inputclr {
  color: rgb(0, 173, 208);
  font-size: 18px;
  background: transparent;
  margin-left: 0;
  padding-left: 0;
  position: absolute;
  left: 40px;
  top: 18px;
  font-size: 11px;
  background: transparent;
  margin-left: 8px;
}

.loader-container {
  position: absolute;
  left: 0;
  right: 0;
  text-align: center;
  top: 0;
  bottom: 0;
  background: rgba(236, 236, 236, 0.9);
  display: -ms-flexbox;
  display: none;
  justify-content: center;
  align-items: center;
  z-index: 9999999999;
  height: 100vh;
  margin: 0 auto;
}

.stick-challenge {
  position: relative;
}
.stick-challenge .card-body__inner {
  min-height: auto;
  overflow-y: auto;
  overflow-x: hidden;
  z-index: 9;
  position: relative;
  padding-top: 0;
}
.stick-challenge .card-body__inner .card-body__subtitle {
  position: sticky;
  top: 0;
  z-index: 99;
  background-color: #fff;
  padding: 15px 0 15px 35px;
  margin: 0;
}

.row--editmodebg {
  background-color: #fff;
  padding: 40px 35px;
}
.row--wbg {
  background-color: #fff;
}

.swal2-show button.swal2-cancel.swal2-styled.wbg {
  background-color: red !important;
}

.loader-spin {
  background-color: hsla(0, 0%, 92.5%, 0.9);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.loader__inner {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

#Path_129 {
  animation: blink 2s linear infinite;
  opacity: 0;
}

#Path_130 {
  animation: blink 2s linear infinite;
  animation-delay: 0.5s;
  opacity: 0;
}

#Path_132 {
  animation: blink 2s linear infinite;
  animation-delay: 1s;
  opacity: 0;
}

#Path_131 {
  animation: blink 2s linear infinite;
  animation-delay: 1.5s;
  opacity: 0;
}

@keyframes blink {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.cn-dmodal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/challenges/clarify-challenge/clarify-challenge.component.scss","webpack://./src/app/components/challenges/_cn-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;ACvUA;EACI,oCAAA;AD0UJ;;AA/YA;EACI,oBAAA;AAkZJ;;AA/YA;EACI,mBAAA;AAkZJ;;AA9YA;EACI,kBAAA;AAiZJ;;AA5YI;ECCA,aAAA;EAEA,eAAA;EDDI,mBAAA;AAmZR;AAjZQ;EAJJ;IAKQ,mBAAA;EAoZV;AACF;AAlZQ;EACI,mBAAA;AAoZZ;AAhZoB;EACI,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;AAkZxB;AAhZwB;EANJ;IAOQ,kBAAA;IACA,eAAA;EAmZ1B;AACF;AAjZwB;EAXJ;IAYQ,YAAA;IACA,eAAA;EAoZ1B;AACF;AAhZwB;EACI,iCAAA;EACA,qCAAA;EACA,wCAAA;EACA,sCAAA;AAkZ5B;AA3YQ;EACI,gBAAA;AA6YZ;AA3YY;EACI,OAAA;EACA,kBAAA;AA6YhB;AA3YgB;EAJJ;IAKQ,UAAA;IACA,WAAA;EA8YlB;AACF;AA5YgB;EACI,WAAA;EACA,OAAA;AA8YpB;AA5YoB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;AA8YxB;AAvYI;EACI,WAAA;EACA,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;AAyYR;AAvYQ;EAPJ;IAQQ,kBAAA;EA0YV;AACF;AAxYQ;EACI,kCD7EI;ACudhB;AAvYQ;EACI,eAAA;EACA,gBAAA;EACA,SAAA;EC3CR,mCAAA;EACA,8BAAA;ED4CQ,aAAA;EACA,eAAA;EACA,mBAAA;AA0YZ;AAxYY;EATJ;IAUQ,eAAA;EA2Yd;AACF;AAzYY;EAbJ;IAcQ,eAAA;EA4Yd;AACF;AA1YY;EACI,kBAAA;AA4YhB;AAxYY;EACI,WAAA;EACA,cAAA;AA0YhB;AAxYgB;EAJJ;IAKQ,WAAA;IACA,eAAA;EA2YlB;AACF;AAvYQ;ECnHJ,aAAA;EAEA,eAAA;EAYA,mBAAA;EDwGQ,eAAA;AA+YZ;AAzYoB;EACI,qBAAA;AA2YxB;AAzYwB;EAHJ;IAIQ,OAAA;IACA,sBAAA;EA4Y1B;AACF;AAvYY;EACI,eAAA;EACA,qBAAA;AAyYhB;AAvYgB;EACI,sBAAA;AAyYpB;AAtYgB;EACI,UAAA;AAwYpB;AAtYoB;EAHJ;IAIQ,OAAA;IACA,kBAAA;EAyYtB;AACF;AAtYgB;EACI,UAAA;AAwYpB;AAtYoB;EAHJ;IAIQ,YAAA;EAyYtB;AACF;AAtYgB;EACI,UAAA;EACA,iBAAA;EACA,iBAAA;AAwYpB;AAtYoB;EALJ;IAMQ,WAAA;EAyYtB;AACF;AAtYgB;EC1KZ,aAAA;EAEA,eAAA;EAMA,uBAAA;ADkjBJ;AA5YoB;EC9KhB,aAAA;EAEA,eAAA;ED8KoB,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAkZxB;AA7YoC;EACI,uBAAA;AA+YxC;AA3YwC;EADJ;IAEQ,WAAA;EA8Y1C;AACF;AAvYoC;EACI,sBAAA;AAyYxC;AArYwC;EADJ;IAEQ,YAAA;EAwY1C;AACF;AAnY4B;EACI,iBAAA;AAqYhC;AAjYgC;EACI,kBAAA;AAmYpC;AA9XgC;EACI,uBD5NpB;EC6NoB,kCAAA;AAgYpC;AA9XoC;EACI,uBDhOxB;ECiOwB,yBAAA;AAgYxC;AA9XwC;EACI,yBAAA;EACA,WAAA;AAgY5C;AAzXgC;EACI,YAAA;EACA,kCAAA;EACA,uBD/OpB;AC0mBhB;AAzXoC;EACI,uBDlPxB;ECmPwB,yBAAA;AA2XxC;AAzXwC;EACI,yBAAA;EACA,WAAA;AA2X5C;AArX4B;EACI,kBAAA;EACA,wBD7PhB;EC8PgB,eAAA;EACA,iBAAA;ECzN5B,mCAAA;EACA,8BAAA;ED0N4B,qBAAA;EACA,YAAA;EACA,SAAA;EACA,6BAAA;ECpP5B,yBAAA;EDwP4B,gBAAA;AA0XhC;AAxXgC;EACI,kBAAA;EACA,SAAA;EACA,wBAAA;AA0XpC;AAxXoC;EACI,sBDlRxB;AC4oBhB;AAtXgC;EAzBJ;IA0BQ,gBAAA;IACA,eAAA;EAyXlC;AACF;AAvXgC;EACI,aAAA;EACA,gBAAA;AAyXpC;AArXoC;EADJ;IAEQ,aAAA;EAwXtC;AACF;AArXgC;EACI,aAAA;AAuXpC;AArXoC;EAHJ;IAIQ,qBAAA;EAwXtC;AACF;AArXgC;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kCDrTpB;ECsToB,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;AAuXpC;AArXoC;EAfJ;IAgBQ,kBAAA;IACA,SAAA;IACA,YAAA;IACA,QAAA;IACA,SAAA;EAwXtC;AACF;AArXgC;EACI,uBDvUpB;ECwUoB,UAAA;AAuXpC;AApXgC;EACI,uBD5UpB;EC6UoB,yBAAA;EACA,UAAA;AAsXpC;AA/WgB;EACI,kBAAA;AAiXpB;AA7W4B;EACI,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,uCAAA;EACA,kBAAA;AA+WhC;AAzWgC;EACI,uBAAA;AA2WpC;AAnWgC;EACI,cAAA;AAqWpC;AA7VgB;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,cAAA;AA+VpB;AA3VY;EACI,kCAAA;EACA,6BAAA;EACA,iBAAA;EACA,kBAAA;EC/VZ,mCAAA;EACA,8BAAA;EDgWY,uBDzYA;EC0YA,eAAA;EACA,gBAAA;ECzXZ,yBAAA;ED2XY,eAAA;AAgWhB;AA9VgB;EACI,kCDhZJ;ECiZI,WAAA;AAgWpB;AA7VgB;EACI,aAAA;AA+VpB;AA3VY;EACI,eAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;AA6VhB;AA3VgB;EACI,uBDjaJ;AC8vBhB;AA1VgB;EACI,mBAAA;AA4VpB;AAzVgB;EACI,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,uBD5aJ;EC6aI,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AA2VpB;AAtVQ;EACI,eAAA;EACA,SAAA;EACA,eAAA;EACA,uBDhcI;EEwCZ,mCAAA;EACA,8BAAA;EA3CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ADsxBJ;AA7VY;EATJ;IAUQ,eAAA;EAgWd;AACF;AA9VY;EAbJ;IAcQ,eAAA;IACA,sBAAA;EAiWd;AACF;AA/VY;EACI,iBAAA;AAiWhB;AA5VgB;EACI,uBDrdJ;ACmzBhB;AAxVgB;EAFJ;IAGQ,WAAA;IACA,gBAAA;EA2VlB;AACF;AAzVgB;EACI,0BAAA;EACA,8BAAA;EACA,6BAAA;AA2VpB;AAzVoB;EALJ;IAMQ,0BAAA;EA4VtB;AACF;AAxVY;EACI,eAAA;EACA,gBAAA;AA0VhB;AAxVgB;EACI,iBAAA;AA0VpB;AAxVoB;EACI,cAAA;EACA,gBAAA;AA0VxB;AAtVgB;EACI,iBAAA;AAwVpB;AAhVI;;EAEI,cAAA;EACA,gBAAA;AAkVR;AA/UI;EA8EI,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,yCAAA;AAoQR;AApVQ;EACI,gBAAA;AAsVZ;AApVY;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAsVhB;AAnVY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAqVhB;AAnVgB;EACI,mBAAA;EACA,kBAAA;AAqVpB;AAjVY;EACI,gBAAA;AAmVhB;AA/UQ;EACI,gBAAA;AAiVZ;AA9UQ;EACI,SAAA;EACA,kCAAA;EACA,kBAAA;AAgVZ;AA9UY;EACI,6BAAA;EACA,4BAAA;AAgVhB;AA9UgB;EACI,kCDljBJ;ACk4BhB;AA7UwB;EACI,WAAA;AA+U5B;AAzUgC;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;AA2UpC;AAzUoC;EACI,uBDlkBxB;ECmkBwB,sBAAA;AA2UxC;AAxUoC;EACI,UAAA;AA0UxC;AAnUoB;EACI,WAAA;AAqUxB;AA1TQ;EACI,kBAAA;EACA,gBAAA;AA4TZ;AA1TY;EAJJ;IAKQ,kBAAA;EA6Td;AACF;AA1TQ;EACI,aAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,gBAAA;AA4TZ;AA1TY;EACI,cAAA;AA4ThB;AA1TgB;EACI,sBAAA;AA4TpB;AAtTgB;EACI,eAAA;EACA,gBAAA;AAwTpB;AAtToB;EAJJ;IAKQ,eAAA;EAyTtB;AACF;AAvToB;EACI,gBAAA;AAyTxB;AArTgB;ECnoBZ,aAAA;EAEA,eAAA;EDmoBgB,eAAA;AA2TpB;AAzToB;EACI,UAAA;EACA,eAAA;AA2TxB;AAzTwB;EAJJ;IAKQ,WAAA;EA4T1B;AACF;AAvToB;EACI,kBAAA;EACA,kBAAA;AAyTxB;AAvTwB;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AAyT5B;AAnTY;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;AAqThB;AAnTgB;EACI,eAAA;AAqTpB;AAlTgB;EACI,gBAAA;AAoTpB;AAjTgB;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAmTpB;AAjToB;EACI,QAAA;AAmTxB;AA9SgB;EACI,cAAA;EACA,eAAA;AAgTpB;AA9SoB;EACI,iBAAA;AAgTxB;AAzSY;EACI,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA2ShB;AAzSgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,YAAA;AA2SpB;AAxSgB;EACI,sBAAA;AA0SpB;AAtSY;EACI,UAAA;EACA,SAAA;EACA,aAAA;AAwShB;AAtSgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AAwSpB;AAtSoB;EACI,kBAAA;EACA,uBD9uBR;EC+uBQ,UAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AAwSxB;AAnSoB;EACI,8BD3vBR;ACgiChB;AAlSoB;EACI,UAAA;AAoSxB;AA7RY;EACI,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AA+RhB;AA7RgB;EACI,kBAAA;EACA,QAAA;EACA,iBAAA;AA+RpB;AA5RgB;EACI,sBAAA;AA8RpB;AA1RY;EACI,UAAA;EACA,kBAAA;EACA,aAAA;AA4RhB;AA1RgB;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AA4RpB;AA1RoB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;AA4RxB;AAvRoB;EACI,qBAAA;EACA,yBAAA;AAyRxB;AAtRoB;EACI,UAAA;AAwRxB;AAlRQ;EACI,yBAAA;EACA,6BAAA;EACA,kBAAA;AAoRZ;AAlRY;EC90BR,aAAA;EAEA,eAAA;EAYA,mBAAA;AD4lCJ;AAxRgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;ECl0BhB,yBAAA;AD+lCJ;AA1RoB;EACI,iBAAA;AA4RxB;AAzRoB;EACI,iBAAA;EACA,gBAAA;AA2RxB;AAvRgB;EACI,iBAAA;AAyRpB;AAtRgB;EACI,kCDt2BJ;ECu2BI,8BDv2BJ;ECw2BI,WAAA;AAwRpB;AAtRoB;EACI,kCD32BR;EC42BQ,8BD52BR;ACooChB;AApRgB;EACI,UAAA;EACA,iBAAA;AAsRpB;AAnRgB;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;AAqRpB;AAnRoB;EACI,yBAAA;EACA,qBAAA;AAqRxB;AAhRoB;EACI,SAAA;AAkRxB;AA9QgB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EC33BhB,yBAAA;AD8oCJ;AAhRoB;EACI,kBAAA;EACA,UAAA;ECh4BpB,yBAAA;ADqpCJ;AAjRoB;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAmRxB;AAjRwB;EACI,kBAAA;EACA,OAAA;AAmR5B;AAhRwB;EACI,iBAAA;AAkR5B;AA9QoB;EAEI,eAAA;ECt5BpB,yBAAA;ADwqCJ;AA3QQ;EACI,gBAAA;EACA,kBAAA;EACA,6BAAA;AA6QZ;AA1QY;EANJ;IAOQ,kBAAA;EA6Qd;AACF;AA3QY;EACI,cAAA;EC57BZ,aAAA;EAEA,eAAA;EAYA,mBAAA;ADmsCJ;AAjRgB;EACI,cAAA;AAmRpB;AAjRoB;EAHJ;IAIQ,WAAA;IACA,kBAAA;EAoRtB;EAlRsB;IACI,gBAAA;EAoR1B;AACF;AAhRwB;EACI,iBAAA;AAkR5B;AA7QgB;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;AA+QpB;AA7QoB;EARJ;IASQ,eAAA;EAgRtB;AACF;AA5QwB;EACI,YAAA;AA8Q5B;AA1QoB;;EAEI,iBAAA;EACA,gBAAA;AA4QxB;AAzQoB;EACI,mCDz+BR;EC0+BQ,WAAA;AA2QxB;AAxQoB;EACI,kCDh/BR;ECi/BQ,WAAA;EACA,8BDl/BR;ECm/BQ,gBAAA;EACA,wBAAA;AA0QxB;AAtQoB;EACI,yBAAA;AAwQxB;AArQoB;EACI,UAAA;EACA,6BAAA;EACA,cAAA;EACA,cDl/BH;ECm/BG,SAAA;EACA,wEDvhCX;ECwhCW,eAAA;EACA,gBAAA;EACA,yBAAA;AAuQxB;AArQwB;EACI,yBAAA;EACA,WAAA;AAuQ5B;AAnQoB;EACI,yBAAA;EACA,WAAA;EACA,qBAAA;AAqQxB;AAlQoB;EACI,cAAA;AAoQxB;AAjQoB;EACI,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EC7gCpB,yBAAA;ADmxCJ;AApQwB;EACI,eAAA;EACA,cDrhCP;AC2xCrB;AAjQwB;EACI,kBAAA;EACA,UAAA;ECxhCxB,yBAAA;AD8xCJ;AAlQwB;EACI,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAoQ5B;AAlQ4B;EANJ;IAOQ,kBAAA;IACA,iBAAA;EAqQ9B;AACF;AAnQ4B;EACI,kBAAA;EACA,OAAA;AAqQhC;AAlQ4B;EACI,iBAAA;EACA,cAAA;AAoQhC;AAhQwB;EA7CJ;IA8CQ,yBAAA;IACA,cAAA;IACA,mBAAA;IACA,kBAAA;EAmQ1B;AACF;AAlQ4B;EAnDR;IAoDY,kBAAA;IACA,iBAAA;EAqQ9B;AACF;AA9QwB;EAWI;IACI,kBAAA;IACA,OAAA;EAsQ9B;EAnQ0B;IACI,4BAAA;EAqQ9B;AACF;AAlQwB;EAEI,eAAA;ECzkCxB,yBAAA;AD+0CJ;AA3PQ;EACI,mBAAA;AA6PZ;AA3PY;EACI,uBD1mCA;ACu2ChB;AAzPQ;EACI,uBD/mCI;ECgnCJ,eAAA;AA2PZ;AAxPQ;EACI,kBAAA;AA0PZ;AAxPY;;EAEI,WAAA;EACA,eAAA;EACA,kBAAA;AA0PhB;AAxPgB;;;;EAEI,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AA4PpB;AAvPoB;;EACI,aAAA;AA0PxB;AApPoB;;EACI,kBAAA;AAuPxB;AArPwB;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBDvpCZ;AC+4ChB;AAtP4B;;;EAEI,cAAA;AAyPhC;AAtP4B;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAyPhC;AArPwB;;EACI,kBAAA;AAwP5B;AAjPY;EACI,eAAA;ECxrCZ,aAAA;EAEA,eAAA;AD86CJ;AArPgB;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAuPpB;AArPoB;EACI,aAAA;AAuPxB;AApPoB;EACI,aAAA;AAsPxB;AAnPoB;EACI,UAAA;AAqPxB;AAlPoB;EACI,kBAAA;AAoPxB;AAhPgB;EAGI,gBAAA;EACA,iFAAA;EACA,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,wBAAA;AAkPpB;AAhPoB;EAGI,aAAA;AAgPxB;AA5OgB;;ECluCZ,aAAA;EAEA,eAAA;ADo9CJ;AAhPoB;;EACI,WAAA;EACA,mBAAA;ECxuCpB,aAAA;EAEA,eAAA;EAYA,mBAAA;ED6tCoB,gBAAA;AAyPxB;AAtPoB;;EACI,WAAA;EACA,kBAAA;EChvCpB,aAAA;EAEA,eAAA;EAYA,mBAAA;EANA,uBAAA;ED4uCoB,eAAA;EACA,0BAAA;AAiQxB;AA/PwB;;EACI,wBAAA;AAkQ5B;AA/PwB;;EACI,gBAAA;EACA,gBAAA;AAkQ5B;AA9PoB;;EACI,YAAA;EACA,mBAAA;AAiQxB;AA/PwB;EAJJ;;IAKQ,WAAA;IACA,gBAAA;IACA,mBAAA;EAmQ1B;AACF;AAhQoB;;EACI,yBAAA;EACA,mBAAA;AAmQxB;AAjQwB;;EACI,mBAAA;EACA,wBAAA;AAoQ5B;AAlQ4B;;;;EAGI,aAAA;AAqQhC;AAjQwB;EAfJ;;IAgBQ,WAAA;EAqQ1B;AACF;AAjQ4B;EADJ;;IAEQ,SAAA;IACA,uBAAA;IACA,WAAA;EAqQ9B;AACF;AAlQwB;;EACI,kBAAA;AAqQ5B;AAnQ4B;;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;EACA,uBD/yChB;ACqjDhB;AApQgC;;;EAEI,cAAA;AAuQpC;AApQgC;;EACI,aAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AAuQpC;AAnQ4B;;EACI,kBAAA;AAsQhC;AAhQoB;;EACI,WAAA;AAmQxB;AA5PgB;EACI,cAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cD90CC;EEIjB,yBAAA;ED40CgB,gBAAA;AAgQpB;AA9PoB;EACI,kCDj2CR;ECk2CQ,kCAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAgQxB;AA1PQ;EAQI,oBAAA;ECv2CR,mBAAA;EDy2CQ,WAAA;EACA,gBAAA;EACA,SAAA;AAyPZ;AApQY;EACI,kBAAA;EACA,SAAA;AAsQhB;AA1PY;EACI,kBAAA;EACA,gCAAA;AA4PhB;AA1PgB;EAEI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,yBAAA;AA2PpB;AAxPgB;EACI,WAAA;EACA,UAAA;AA0PpB;AAtPY;EACI,YAAA;EACA,kBAAA;AAwPhB;AArPY;;EAEI,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAuPhB;AApPY;EACI,WAAA;EACA,SAAA;AAsPhB;AAnPY;EACI,SAAA;AAqPhB;AAlPY;EACI,UAAA;EACA,iBAAA;AAoPhB;AAhPQ;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,wBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,QAAA;EAGA,2BAAA;EC56CR,yBAAA;ADiqDJ;AAlPY;EACI,kCDl8CA;ECm8CA,8BDn8CA;ECo8CA,WAAA;AAoPhB;AA9OQ;EACI,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EC57CR,yBAAA;AD+qDJ;AAhPY;EACI,YAAA;AAkPhB;AA/OY;EACI,gBAAA;AAiPhB;AA9OY;EACI,kCD19CA;AC0sDhB;AA7OY;EACI,kCD79CD;AC4sDf;AA5OY;EACI,kCD/9CE;AC6sDlB;AAzOI;ECz+CA,aAAA;EAEA,eAAA;EDy+CI,sBAAA;AA+OR;AA5OI;EACI,aAAA;AA8OR;AA3OI;EACI,kCAAA;AA6OR;AA1OI;ECt/CA,aAAA;EAEA,eAAA;EAYA,mBAAA;ED2+CI,mBAAA;AAkPR;AAhPQ;EACI,wBAAA;EACA,qBAAA;EACA,kBAAA;AAkPZ;AAhPY;EACI,WAAA;EACA,kBAAA;EClgDZ,aAAA;EAEA,eAAA;ADuvDJ;AApPgB;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kCAAA;AAsPpB;;AAzOA;EACI,eAAA;AA4OJ;AA1OI;EC1hDA,aAAA;EAEA,eAAA;EAYA,mBAAA;ED+gDI,UAAA;EACA,SAAA;AAkPR;AA/OI;EACI,gBAAA;AAiPR;AA/OQ;EACI,iBAAA;AAiPZ;AA7OY;EACI,UAAA;AA+OhB;AA3OQ;EACI,kCD7iDI;EC8iDJ,WAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AA6OZ;AA3OY;EACI,SAAA;AA6OhB;AAzOQ;EChhDJ,mCAAA;EACA,8BAAA;EDihDQ,eAAA;EACA,cAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EC5iDR,yBAAA;AD2xDJ;AA5OY;EACI,kBAAA;EACA,gBAAA;EACA,OAAA;ECljDZ,yBAAA;ADmyDJ;;AApOA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;AAuOJ;;AApOA;EACI,eAAA;AAuOJ;AArOI;EACI,iBAAA;EAEA,sBAAA;EACA,qBAAA;EACA,cAAA;AAsOR;AAnOI;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,YAAA;AAqOR;;AA1NQ;EACI,aAAA;EACA,qCAAA;EACA,cAAA;AA6NZ;AA3NY;EALJ;IAMQ,0BAAA;EA8Nd;AACF;AA5NY;EACI,aAAA;EACA,eAAA;AA8NhB;AA5NgB;EACI,OAAA;AA8NpB;AA5NoB;EAHJ;IAIQ,UAAA;IACA,WAAA;EA+NtB;AACF;AA1NY;EACI,0BAAA;AA4NhB;AAxNgB;EACI,0BAAA;AA0NpB;AArNoB;EACI,aAAA;AAuNxB;AAjNoB;EACI,aAAA;AAmNxB;AA7MoB;EACI,aAAA;AA+MxB;AAzMoB;EACI,aAAA;AA2MxB;AArMoB;EACI,aAAA;AAuMxB;AAjMQ;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;AAmMZ;AAjMY;EACI,kCAAA;EACA,uBDnsDA;ECosDA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;AAmMhB;AA/LY;EAlBJ;IAmBQ,eAAA;EAkMd;AACF;AAhMY;EACI,uBDjtDA;ECktDA,kBAAA;AAkMhB;AAhMgB;;EAEI,cAAA;AAkMpB;AA9LY;EACI,eAAA;EACA,gBAAA;AAgMhB;AA9LgB;EAJJ;IAKQ,eAAA;EAiMlB;AACF;AA/LgB;EACI,gBAAA;AAiMpB;;AAzLA;EACI,kBAAA;AA4LJ;AA1LI;EACI,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,6BAAA;EACA,eAAA;AA4LR;AA1LQ;EACI,6BAAA;AA4LZ;AAzLQ;EACI,uBD7vDI;EC8vDJ,eAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,uBAAA;EACA,gBAAA;AA2LZ;;AAtLA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EAEA,oBAAA;EACA,aAAA;EAGA,uBAAA;EAGA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;AAyLJ;;AAtLA;EACI,kBAAA;AAyLJ;AAvLI;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAyLR;AAvLQ;EACI,gBAAA;EACA,MAAA;EACA,WAAA;EACA,sBAAA;EACA,yBAAA;EACA,SAAA;AAyLZ;;AAlLI;EACI,sBAAA;EACA,kBAAA;AAqLR;AAlLI;EACI,sBAAA;AAoLR;;AAhLA;EACI,gCAAA;AAmLJ;;AAhLA;EACI,yCAAA;EACA,eAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;AAmLJ;;AAhLA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;AAmLJ;;AA/KA;EACI,mCAAA;EACA,UAAA;AAkLJ;;AA/KA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AAkLJ;;AA/KA;EACI,mCAAA;EACA,mBAAA;EACA,UAAA;AAkLJ;;AA/KA;EACI,mCAAA;EACA,qBAAA;EACA,UAAA;AAkLJ;;AA/KA;EACI;IACI,UAAA;EAkLN;EA/KE;IACI,UAAA;EAiLN;EA9KE;IACI,UAAA;EAgLN;AACF;AA5KA;EACI,aAAA;AA8KJ","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import './../cn-shared';\n\n\n\n::ng-deep#page-wrapper {\n    padding-bottom: 60px;\n}\n\n::ng-deep#wrapper {\n    overflow-x: initial;\n\n}\n\n::ng-deep.wrapper-content {\n    position: relative;\n}\n\n::ng-deep.clarify-is {\n\n    .mainnav {\n        @include fflex();\n        margin: 30px 0 40px;\n\n        @media #{$mq-sm} {\n            margin: 10px 0 30px;\n        }\n\n        &.mainnav--bottom {\n            margin: 30px 0 40px;\n\n            ul {\n                li {\n                    a {\n                        padding: 12px 30px;\n                        font-family: 'Open Sans', sans-serif;\n                        font-weight: 700;\n                        font-size: 16px;\n\n                        @media only screen and (max-width: 991px) {\n                            padding: 10px 20px;\n                            font-size: 14px;\n                        }\n\n                        @media only screen and (max-width: 767px) {\n                            padding: 9px;\n                            font-size: 11px;\n                        }\n                    }\n\n                    &.active {\n                        a {\n                            background-color: #bbb !important;\n                            border-top: 1px solid #bbb !important;\n                            border-bottom: 1px solid #bbb !important;\n                            border-left: 1px solid #bbb !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &--editmode {\n            margin: 0 0 15px;\n\n            .mainnav__list {\n                flex: 1;\n                border-radius: 5px;\n\n                @media #{$mq-sm} {\n                    flex: none;\n                    width: 100%;\n                }\n\n                li {\n                    width: 100%;\n                    flex: 1;\n\n                    a {\n                        width: 100%;\n                        padding: 5px 2px;\n                        text-align: center;\n                    }\n                }\n            }\n        }\n    }\n\n    .info {\n        color: #fff;\n        border: 1px solid $clarify-color;\n        margin-bottom: 18px;\n        padding: 20px 40px;\n        border-radius: 6px;\n\n        @media #{$mq-md} {\n            padding: 12px 20px;\n        }\n\n        &.infotitle {\n            background-color: $clarify-color;\n        }\n\n        h1 {\n            font-size: 36px;\n            font-weight: 500;\n            margin: 0;\n            @include headingfont();\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n\n            @media #{$mq-md} {\n                font-size: 28px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 24px;\n            }\n\n            .info__maintitle {\n                margin-right: auto;\n\n            }\n\n            small {\n                color: #fff;\n                font-size: 80%;\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 5px;\n                }\n            }\n        }\n\n        .card__toprow {\n            @include fflex();\n            @include fflex-aic();\n            margin: 0 -15px;\n\n            &--tne {\n\n                .card__topcol {\n\n                    &:first-child {\n                        width: 72% !important;\n\n                        @media #{$mq-sm} {\n                            flex: 1;\n                            width: auto !important;\n                        }\n                    }\n                }\n            }\n\n            .card__topcol {\n                padding: 0 15px;\n                width: calc(100% / 3);\n\n                &--full {\n                    width: 100% !important;\n                }\n\n                &:nth-child(1) {\n                    width: 28%;\n\n                    @media #{$mq-sm} {\n                        flex: 1;\n                        margin-right: auto;\n                    }\n                }\n\n                &--tab {\n                    width: 44%;\n\n                    @media #{$mq-sm} {\n                        width: 120px;\n                    }\n                }\n\n                &--tt {\n                    width: 28%;\n                    margin-left: auto;\n                    text-align: right;\n\n                    @media #{$mq-sm} {\n                        width: auto;\n                    }\n                }\n\n                &.card__topcol--tab {\n                    @include fflex();\n                    @include fflex-jcc();\n\n                    ul {\n                        @include fflex();\n                        margin: 0;\n                        padding: 0;\n                        border-radius: 3px;\n                        line-height: 1;\n\n                        li {\n                            &:first-child {\n                                button {\n                                    svg {\n                                        right: calc(100% + 1px)\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            left: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:last-child {\n                                button {\n                                    svg {\n                                        left: calc(100% + 1px);\n                                    }\n\n                                    span.card__topcount {\n                                        @media only screen and (max-width: 630px) {\n                                            right: -30px;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &:not(:first-child) {\n                                margin-left: -1px;\n                            }\n\n                            &:only-child {\n                                button {\n                                    border-radius: 3px;\n                                }\n                            }\n\n                            &.card__topactive {\n                                button {\n                                    color: $clarify-color;\n                                    border: 1px solid $clarify-color;\n\n                                    span.card__topcount {\n                                        color: $clarify-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            &.card__topcomplete {\n                                button {\n                                    opacity: 0.2;\n                                    border: 1px solid $clarify-color;\n                                    color: $clarify-color;\n\n                                    span.card__topcount {\n                                        color: $clarify-color;\n                                        background-color: #efefef;\n\n                                        &.redConverge_count {\n                                            background-color: #EC2121;\n                                            color: #fff;\n                                        }\n                                    }\n                                }\n                            }\n\n                            button {\n                                position: relative;\n                                color: $develop-color;\n                                font-size: 17px;\n                                padding: 6px 16px;\n                                @include headingfont();\n                                display: inline-block;\n                                height: 100%;\n                                border: 0;\n                                background-color: transparent;\n                                @include transition-slow();\n                                -webkit-appearance: none;\n                                -moz-appearance: none;\n                                appearance: none;\n\n                                svg {\n                                    position: absolute;\n                                    top: -1px;\n                                    height: calc(100% + 2px);\n\n                                    .st0 {\n                                        fill: $clarify-color;\n                                    }\n                                }\n\n                                @media #{$mq-md} {\n                                    padding: 4px 6px;\n                                    font-size: 13px;\n                                }\n\n                                &:focus {\n                                    outline: none;\n                                    box-shadow: none;\n                                }\n\n                                &>.card__topdesktext {\n                                    @media only screen and (max-width: 1180px) {\n                                        display: none;\n                                    }\n                                }\n\n                                &>.card__topmobiletext {\n                                    display: none;\n\n                                    @media only screen and (max-width: 1180px) {\n                                        display: inline-block;\n                                    }\n                                }\n\n                                &>span.card__topcount {\n                                    width: 16px;\n                                    height: 16px;\n                                    line-height: 16px;\n                                    display: inline-block;\n                                    text-align: center;\n                                    font-size: 0.5em;\n                                    background-color: $clarify-color;\n                                    color: #fff;\n                                    margin-left: 4px;\n                                    border-radius: 50%;\n                                    vertical-align: bottom;\n                                    position: relative;\n                                    top: -1px;\n\n                                    @media only screen and (max-width: 630px) {\n                                        position: absolute;\n                                        top: auto;\n                                        bottom: -2px;\n                                        right: 0;\n                                        margin: 0;\n                                    }\n                                }\n\n                                &:hover {\n                                    color: $clarify-color;\n                                    opacity: 1;\n                                }\n\n                                &:hover>span.card__topcount {\n                                    color: $clarify-color;\n                                    background-color: #efefef;\n                                    opacity: 1;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                &--ctt {\n                    position: relative;\n\n                    ul {\n                        li {\n                            .card-body__tooltip {\n                                display: none;\n                                position: absolute;\n                                background: #fff;\n                                color: #676a6c;\n                                padding: 5px;\n                                top: -27px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                border-radius: 5px;\n\n                            }\n\n                            button {\n\n                                &:hover {\n                                    opacity: 0.2 !important;\n                                }\n\n                            }\n\n                            &:hover,\n                            &:active {\n\n                                .card-body__tooltip {\n                                    display: block;\n                                }\n                            }\n\n                        }\n                    }\n                }\n\n                span.flagicon {\n                    position: relative;\n                    right: -6px;\n                    top: -11px;\n                    color: #ff0000;\n                    margin-left: 0;\n                }\n            }\n\n            .card__h3button {\n                border: 1px solid $clarify-color;\n                background-color: transparent;\n                padding: 2px 26px;\n                border-radius: 3px;\n                @include headingfont();\n                color: $clarify-color;\n                font-size: 22px;\n                line-height: 1.2;\n                @include transition-slow();\n                cursor: pointer;\n\n                &:hover {\n                    background-color: $clarify-color;\n                    color: #fff;\n                }\n\n                &:focus {\n                    outline: none;\n                }\n            }\n\n            .tooltipicon {\n                cursor: pointer;\n                position: relative;\n                font-size: 18px;\n                display: inline-block;\n                text-align: right;\n\n                i {\n                    color: $clarify-color;\n                }\n\n                &:hover>i>.tooltiptext {\n                    visibility: visible;\n                }\n\n                .tooltiptext {\n                    visibility: hidden;\n                    width: 250px;\n                    background-color: #fff;\n                    color: $clarify-color;\n                    text-align: center;\n                    border-radius: 6px;\n                    padding: 10px;\n                    box-shadow: 0 0 18px rgba(0, 0, 0, 0.1);\n                    font-size: 13px;\n                    font-family: 'Open Sans', sans-serif;\n                    line-height: 1.5;\n                    position: absolute;\n                    top: 15px;\n                    right: 10px;\n                    z-index: 1;\n                }\n            }\n        }\n\n        h3 {\n            font-size: 20px;\n            margin: 0;\n            cursor: pointer;\n            color: $clarify-color;\n            @include headingfont();\n            @include fflex();\n            @include fflex-aic();\n\n            @media #{$mq-md} {\n                font-size: 16px;\n            }\n\n            @media #{$mq-sm} {\n                font-size: 15px;\n                word-break: break-word;\n            }\n\n            &>*:not(:last-child) {\n                margin-right: 5px;\n            }\n\n            .card__bwnh3pencil {\n\n                a {\n                    color: $clarify-color;\n                }\n            }\n\n            .card__bwnh3button {\n\n                @media #{$mq-sm} {\n                    width: 100%;\n                    margin-top: 10px;\n                }\n\n                button {\n                    font-size: 18px !important;\n                    padding-right: 15px !important;\n                    padding-left: 15px !important;\n\n                    @media #{$mq-sm} {\n                        font-size: 16px !important;\n                    }\n                }\n            }\n\n            i {\n                cursor: pointer;\n                font-size: 0.9em;\n\n                &+div {\n                    padding-left: 7px;\n\n                    span {\n                        display: block;\n                        font-size: 0.7em;\n                    }\n                }\n\n                &+span {\n                    padding-left: 7px;\n                }\n            }\n\n        }\n\n    }\n\n    app-clarify-data,\n    app-clarify-sub-challenge {\n        display: block;\n        margin-top: 30px;\n    }\n\n    .card-default {\n        &.card-default--summary {\n            box-shadow: none;\n\n            .info {\n                border-top: 0;\n                border-right: 0;\n                border-left: 0;\n                padding-right: 20px;\n                padding-left: 20px;\n            }\n\n            .card-body {\n                border-right: 0;\n                border-bottom: 0;\n                border-left: 0;\n                border-radius: 0;\n\n                &__inner {\n                    padding-right: 20px;\n                    padding-left: 20px;\n                }\n            }\n\n            &+div {\n                margin-top: 20px;\n            }\n        }\n\n        &+div {\n            margin-top: 30px;\n        }\n\n        .info {\n            margin: 0;\n            border: 1px solid $clarify-color;\n            border-radius: 6px;\n\n            &.card__headactive {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n\n                &.card__headactive--cc {\n                    background-color: $clarify-color;\n\n                    .card__topcol {\n                        h3 {\n                            color: #fff;\n                        }\n\n                        ul {\n                            li {\n\n                                button {\n                                    border-color: #fff;\n                                    background-color: #fff;\n                                    cursor: pointer;\n\n                                    span {\n                                        color: $clarify-color;\n                                        background-color: #fff;\n                                    }\n\n                                    .st0 {\n                                        fill: #fff;\n                                    }\n                                }\n                            }\n                        }\n                    }\n\n                    i {\n                        color: #fff;\n                    }\n                }\n            }\n        }\n\n        border-radius: 6px;\n        border-top-width: 3px;\n        border: 0;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);\n\n        .card-body__inner {\n            padding: 15px 40px;\n            overflow-y: auto;\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n        }\n\n        .card-body {\n            display: none;\n            border: 1px solid $cn-border-color;\n            border-top: 0;\n            border-radius: 0 0 6px 6px;\n            overflow: hidden;\n\n            &.card-show {\n                display: block;\n\n                &__wbg {\n                    background-color: #fff;\n                }\n\n            }\n\n            &__finalstate {\n                p {\n                    font-size: 15px;\n                    font-weight: 600;\n\n                    @media #{$mq-sm} {\n                        font-size: 13px;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                &--2 {\n                    @include fflex();\n                    margin: 0 -10px;\n\n                    &>div {\n                        width: calc(100% / 2);\n                        padding: 0 10px;\n\n                        @media only screen and (max-width: 767px) {\n                            width: 100%;\n                        }\n                    }\n                }\n\n                &--list {\n                    p {\n                        position: relative;\n                        padding-left: 10px;\n\n                        &::before {\n                            content: \"\";\n                            position: absolute;\n                            top: 8px;\n                            left: 0;\n                            width: 5px;\n                            height: 5px;\n                            border-radius: 50%;\n                            background-color: #444;\n                        }\n                    }\n                }\n            }\n\n            &__subtitle {\n                padding-left: 35px;\n                margin-bottom: 16px;\n                position: relative;\n\n                &--pl0 {\n                    padding-left: 0;\n                }\n\n                *:last-child {\n                    margin-bottom: 0;\n                }\n\n                &>span {\n                    position: absolute;\n                    top: 0;\n                    right: 2px;\n                    opacity: 0.7;\n                    cursor: pointer;\n\n                    &.eyebtn {\n                        right: 0;\n                    }\n\n                }\n\n                p {\n                    color: #969798;\n                    font-size: 15px;\n\n                    i {\n                        padding-left: 5px;\n                    }\n                }\n            }\n        }\n\n        .c-radio {\n            label {\n                padding-left: 0;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 2px;\n                    margin-right: 6px;\n                    opacity: 0.6;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                margin: 0;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 50%;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        position: absolute;\n                        color: $clarify-color;\n                        opacity: 0;\n                        font-size: 11px;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: $clarify-color;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .checkbox {\n            label {\n                min-height: 20px;\n                padding-left: 0;\n                margin-bottom: 0;\n                font-weight: 400;\n                cursor: pointer;\n                width: 100% !important;\n                font-size: 15px;\n                font-weight: bold;\n                color: #676a6c;\n\n                &>i {\n                    position: relative;\n                    top: 1px;\n                    margin-right: 6px;\n                }\n\n                &>span {\n                    vertical-align: middle;\n                }\n            }\n\n            input {\n                opacity: 0;\n                position: absolute;\n                display: none;\n\n                &+span {\n                    position: relative;\n                    display: inline-block;\n                    vertical-align: top;\n                    width: 20px;\n                    height: 20px;\n                    border-radius: 2px;\n                    border: 1px solid #ccc;\n                    margin-right: 10px;\n                    text-align: center;\n                    vertical-align: middle;\n\n                    &::before {\n                        font-size: 12px;\n                        position: absolute;\n                        color: #fff;\n                        opacity: 0;\n                        top: 50%;\n                        left: 50%;\n                        -webkit-transform: translate(-50%, -50%);\n                        -ms-transform: translate(-50%, -50%);\n                        transform: translate(-50%, -50%);\n                    }\n                }\n\n                &:checked {\n                    &+span {\n                        border-color: #5D9CEC;\n                        background-color: #5D9CEC;\n                    }\n\n                    &+span::before {\n                        opacity: 1;\n                    }\n                }\n            }\n        }\n\n        .card-body__button {\n            background-color: #f5f5f5;\n            border-top: 1px solid #e3e3e3;\n            padding: 12px 40px;\n\n            .card-button {\n                @include fflex();\n                @include fflex-aic();\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    text-align: center;\n                    @include transition-slow();\n\n                    &+.btn {\n                        margin-left: 15px;\n                    }\n\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n                }\n\n                .float-right {\n                    margin-left: auto;\n                }\n\n                .btn-clarify {\n                    background-color: $clarify-color;\n                    border-color: $clarify-color;\n                    color: #fff;\n\n                    &:hover {\n                        background-color: $clarify-color;\n                        border-color: $clarify-color;\n                    }\n                }\n\n                .btn-cancel {\n                    padding: 0;\n                    margin-left: 25px;\n                }\n\n                .btn-danger {\n                    background-color: #fff;\n                    border-color: #fff;\n                    color: #ef6272;\n\n                    &:hover {\n                        background-color: #ED2D2D;\n                        border-color: #EC2121;\n                    }\n                }\n\n                .btn-warning {\n                    em {\n                        margin: 0;\n                    }\n                }\n\n                .btn-deleteall {\n                    border: 0;\n                    background-color: transparent;\n                    position: relative;\n                    overflow: hidden;\n                    box-shadow: none;\n                    padding-right: 0;\n                    padding-left: 0;\n                    @include transition-slow();\n\n                    span {\n                        position: absolute;\n                        left: 110%;\n                        @include transition-slow();\n                    }\n\n                    &:hover {\n                        background-color: #fff;\n                        color: #ed5562;\n                        padding-right: 16px;\n                        padding-left: 16px;\n\n                        &>span {\n                            position: relative;\n                            left: 0;\n                        }\n\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n\n                    i {\n\n                        margin-right: 0;\n                        @include transition-slow();\n                    }\n                }\n            }\n        }\n\n        .card-body--ebtn {\n            margin-top: 15px;\n            padding: 15px 40px;\n            border-top: 1px solid $cn-border-color;\n\n\n            @media #{$mq-md} {\n                padding: 12px 20px;\n            }\n\n            .card-body--ebtnrow {\n                margin: 0 -8px;\n                @include fflex();\n                @include fflex-aic();\n\n                &>div {\n                    padding: 0 8px;\n\n                    @media #{$mq-sm} {\n                        width: 100%;\n                        text-align: center;\n\n                        &+div {\n                            margin-top: 10px;\n                        }\n                    }\n\n                    &.card-body--col {\n                        &--last {\n                            margin-left: auto;\n                        }\n                    }\n                }\n\n                .btn {\n                    border-radius: 3px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    padding: 7px 16px;\n                    text-align: center;\n                    transition: all ease 0.3s;\n\n                    @media #{$mq-md} {\n                        font-size: 12px;\n                    }\n\n                    &-bottom {\n\n                        &--disable {\n                            opacity: 0.5;\n                        }\n                    }\n\n                    i,\n                    em {\n                        margin-right: 6px;\n                        font-size: 0.8em;\n                    }\n\n                    &--save {\n                        background-color: $develop-color;\n                        color: #fff;\n                    }\n\n                    &--clarify {\n                        background-color: $clarify-color;\n                        color: #fff;\n                        border-color: $clarify-color;\n                        font-weight: 900;\n                        font-family: 'Open Sans';\n\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                    }\n\n                    &--cancel {\n                        padding: 0;\n                        background-color: transparent;\n                        margin-left: 0;\n                        color: $body-content-color;\n                        border: 0;\n                        font-family: $font-stack;\n                        font-size: 14px;\n                        font-weight: 700;\n                        transition: all ease .3s;\n\n                        &:hover {\n                            transition: all ease .3s;\n                            color: #000;\n                        }\n                    }\n\n                    &--tracking {\n                        background-color: #6d6e71;\n                        color: #fff;\n                        border-color: #6d6e71;\n                    }\n\n                    &--converge {\n                        padding: 0 8px;\n                    }\n\n                    &--deleteall {\n                        border: 0;\n                        background-color: transparent;\n                        position: relative;\n                        overflow: hidden;\n                        box-shadow: none;\n                        padding-right: 0;\n                        padding-left: 0;\n                        cursor: pointer;\n\n                        i {\n                            font-size: 14px;\n                            color: $body-content-color;\n                        }\n\n                        @include transition-slow();\n\n                        span {\n                            position: absolute;\n                            left: 110%;\n                            @include transition-slow();\n                        }\n\n                        &:hover {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            i {\n                                margin-right: 6px;\n                                color: #ed5562;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            background-color: #f5f5f5;\n                            color: #ed5562;\n                            padding-right: 16px;\n                            padding-left: 16px;\n\n                            @media #{$mq-sm} {\n                                padding-right: 7px;\n                                padding-left: 7px;\n                            }\n\n                            &>span {\n                                position: relative;\n                                left: 0;\n                            }\n\n                            i {\n                                margin-right: 6px !important;\n                            }\n                        }\n\n                        i {\n                            // font-size: 1em;\n                            margin-right: 0;\n                            @include transition-slow();\n                        }\n                    }\n                }\n            }\n        }\n\n\n\n\n        .note-3 {\n            margin-bottom: 15px;\n\n            label {\n                color: $clarify-color;\n            }\n        }\n\n        .footer-line {\n            color: $clarify-color;\n            font-size: 15px;\n        }\n\n        .card-body__edit {\n            position: relative;\n\n            .breakthrough-input-tabs,\n            .datadump-input-tabs {\n                width: 100%;\n                margin-right: 0;\n                position: relative;\n\n                input,\n                select {\n                    height: 45px;\n                    padding: 5px 15px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 4px;\n                    font-size: 15px;\n                }\n\n                .card-body__minus {\n\n                    &--hide {\n                        display: none;\n                    }\n                }\n\n                .card-body__editinput {\n\n                    &--ce {\n                        position: relative;\n\n                        .converge-icon {\n                            position: absolute;\n                            top: 50%;\n                            transform: translateY(-50%);\n                            left: 7px;\n                            font-size: 26px;\n                            color: $clarify-color;\n\n                            &:hover>.card-body__tooltip,\n                            &:active>.card-body__tooltip {\n                                display: block;\n                            }\n\n                            .card-body__tooltip {\n                                display: none;\n                                font-size: 16px;\n                                color: #676a6c;\n                                position: absolute;\n                                bottom: 100%;\n                                left: 0;\n                                background: #fff;\n                                padding: 5px;\n                                border-radius: 5px;\n                                box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                width: max-content;\n                            }\n                        }\n\n                        input {\n                            padding-left: 26px;\n                        }\n\n                    }\n                }\n            }\n\n            .card-body__editrow {\n                margin: 0 -15px;\n                @include fflex();\n\n                &>div {\n                    padding: 0 15px;\n                    width: 100%;\n                    margin-bottom: 15px;\n\n                    &:first-child {\n                        display: none;\n                    }\n\n                    &.card-body__editcol.hideblk {\n                        display: none;\n                    }\n\n                    &.card-body__editcol--2 {\n                        width: calc(100% / 2);\n                    }\n\n                    &>div {\n                        position: relative;\n                    }\n                }\n\n                select {\n                    -webkit-appearance: none;\n                    -moz-appearance: none;\n                    appearance: none;\n                    background-image: url($assets+'/images/select.png');\n                    background-size: 10px;\n                    background-position: right 10px center;\n                    background-repeat: no-repeat;\n                    font-family: 'Open Sans';\n\n                    &:hover,\n                    &:focus,\n                    &:active {\n                        outline: none\n                    }\n                }\n\n                .datadump-input-tabs,\n                .breakthrough-input-tabs {\n                    @include fflex();\n\n                    &>.card-body__editlabel {\n                        width: 35px;\n                        padding-right: 15px;\n                        @include fflex();\n                        @include fflex-aic();\n                        font-weight: 700;\n                    }\n\n                    &>.card-body__editnumber {\n                        width: 40px;\n                        text-align: center;\n                        @include fflex();\n                        @include fflex-aic();\n                        @include fflex-jcc;\n                        border-right: 0;\n                        border-radius: 4px 0 0 4px;\n\n                        &+.card-body__editinput {\n                            width: calc(100% - 41px);\n                        }\n\n                        label {\n                            margin-bottom: 0;\n                            font-weight: 900;\n                        }\n                    }\n\n                    &>.card-body__editselect {\n                        width: 315px;\n                        padding-right: 15px;\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            padding-right: 0;\n                            margin-bottom: 10px;\n                        }\n                    }\n\n                    &>.card-body__editinput {\n                        width: calc(100% - 351px);\n                        padding-right: 60px;\n\n                        input {\n                            padding-right: 70px;\n                            font-family: 'Open Sans';\n\n                            &:hover,\n                            &:focus,\n                            &:active {\n                                outline: none;\n                            }\n                        }\n\n                        @media #{$mq-sm} {\n                            width: 100%;\n                            ;\n                        }\n\n                        .input-group-text {\n                            @media #{$mq-sm} {\n                                top: auto;\n                                transform: translate(0);\n                                bottom: 9px;\n                            }\n                        }\n\n                        &--ce {\n                            position: relative;\n\n                            .converge-icon {\n                                position: absolute;\n                                top: 50%;\n                                transform: translateY(-50%);\n                                left: 7px;\n                                font-size: 26px;\n                                color: $clarify-color;\n\n                                &:hover>.card-body__tooltip,\n                                &:active>.card-body__tooltip {\n                                    display: block;\n                                }\n\n                                .card-body__tooltip {\n                                    display: none;\n                                    font-size: 16px;\n                                    color: #676a6c;\n                                    position: absolute;\n                                    bottom: 100%;\n                                    left: 0;\n                                    background: #fff;\n                                    padding: 5px;\n                                    border-radius: 5px;\n                                    box-shadow: 0 0 10px rgb(0 0 0 / 20%);\n                                    width: max-content;\n                                }\n                            }\n\n                            input {\n                                padding-left: 26px;\n                            }\n\n                        }\n                    }\n\n                    &>.card-body__editinput:only-child {\n                        width: 100%;\n                    }\n                }\n            }\n\n            &+.card-body__addnew {\n\n                button {\n                    margin: 0 36px;\n                    font-size: 14px;\n                    font-weight: bold;\n                    background-color: transparent;\n                    border: 1px solid transparent;\n                    padding-right: 0;\n                    padding-left: 0;\n                    color: $body-content-color;\n                    @include transition-slow();\n                    font-weight: 900;\n\n                    &:hover {\n                        background-color: $clarify-color;\n                        border: 1px solid $clarify-color;\n                        color: #fff;\n                        padding-right: 12px;\n                        padding-left: 12px;\n                    }\n                }\n            }\n        }\n\n        .input-tabs {\n            &+i {\n                position: relative;\n                top: -1px;\n            }\n\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            @include fflex-aic();\n            width: calc(100%);\n            padding: 0 0 0 0;\n            margin: 0;\n\n\n            &.card__body--cs {\n                position: relative;\n                border-bottom: 1px solid #e4e4e4;\n\n                &::before,\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    bottom: -1px;\n                    right: calc(100%);\n                    width: 40px;\n                    height: 1px;\n                    background-color: #e4e4e4;\n                }\n\n                &::after {\n                    right: auto;\n                    left: calc(100%);\n                }\n            }\n\n            .select_faded {\n                opacity: 0.2;\n                padding-left: 32px;\n            }\n\n            input,\n            select {\n                height: 45px;\n                padding: 9px 15px;\n                border: 1px solid #e3e3e3;\n                border-radius: 4px;\n                margin: 7px 0px;\n            }\n\n            label {\n                width: 20px;\n                margin: 0;\n            }\n\n            select {\n                width: 9%;\n            }\n\n            input {\n                width: 90%;\n                margin-left: 15px;\n            }\n        }\n\n        .input-group-text {\n            cursor: pointer;\n            padding: 3px 16px;\n            margin-bottom: 0;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 1.528571429;\n            color: #495057;\n            text-align: center;\n            white-space: nowrap;\n            background-color: #E9ECEF;\n            border: 1px solid #DDE6E9;\n            border-radius: 0.25rem;\n            position: absolute;\n            top: calc(50% + 1px);\n            right: 0;\n            -webkit-transform: translateY(-50%);\n            -ms-transform: translateY(-50%);\n            transform: translateY(-50%);\n            @include transition-slow();\n\n            &:hover {\n                background-color: $clarify-color;\n                border-color: $clarify-color;\n                color: #fff;\n            }\n        }\n    }\n\n    .card-bottom-button {\n        .button {\n            font-size: 13px;\n            color: #fff;\n            padding: 8px 10px;\n            border-radius: 3px;\n            @include transition-slow();\n\n            &:hover {\n                opacity: .8;\n            }\n\n            i {\n                font-size: 0.8em;\n            }\n\n            &.btn-clarify {\n                background-color: $clarify-color;\n            }\n\n            &.btn-ideate {\n                background-color: $ideate-color;\n            }\n\n            &.btn-implement {\n                background-color: $implement-color;\n            }\n        }\n    }\n\n    .datadump-content-tabs {\n        @include fflex();\n        counter-reset: section;\n    }\n\n    .dump-tabs:first-child {\n        display: none;\n    }\n\n    .dump-tabs {\n        width: calc(50% - 50px) !important;\n    }\n\n    .datadump__col {\n        @include fflex();\n        @include fflex-aic();\n        margin-bottom: 17px;\n\n        .datadump-main {\n            width: calc(100% - 68px);\n            display: inline-block;\n            margin-right: 20px;\n\n            .datadump-group {\n                width: 100%;\n                position: relative;\n                @include fflex();\n\n                input {\n                    margin-bottom: 0px;\n                    width: calc(100%);\n                    height: 35px;\n                    border: 1px solid $color-neutral-mid;\n                    border-radius: 0 0.25rem 0.25rem 0;\n                }\n            }\n        }\n    }\n}\n\n\n\n\n\n\n\n.prevnext {\n    padding: 20px 0;\n\n    &__inner {\n        @include fflex();\n        @include fflex-aic();\n        padding: 0;\n        margin: 0;\n    }\n\n    li {\n        list-style: none;\n\n        &.prevnext__next {\n            margin-left: auto;\n        }\n\n        &.prevnext__prev a {\n            &:hover>i {\n                left: -5px;\n            }\n        }\n\n        &.prevnext__next a {\n            background-color: $clarify-color;\n            color: #fff;\n            opacity: 1;\n            padding: 6px 12px;\n            border-radius: 3px;\n\n            &:hover>i {\n                left: 3px;\n            }\n        }\n\n        a {\n            @include headingfont();\n            font-size: 14px;\n            color: #676a6c;\n            opacity: 0.47;\n            padding: 6px 0;\n            display: inline-block;\n            @include transition-slow();\n\n            i {\n                position: relative;\n                font-size: 1.1em;\n                left: 0;\n                @include transition-slow();\n            }\n        }\n    }\n}\n\n.popaccordian__row--active {\n    // .playbtn{\n    //     transform: rotate(28deg);\n    // }\n}\n\n.playbtn {\n    position: absolute;\n    right: 10px;\n    bottom: 7px;\n    color: #06a6ce;\n}\n\n.Del-data-btn {\n    padding: 40px 0;\n\n    .btn {\n        margin-left: 15px;\n        // border-color: #007bff;\n        background-color: #fff;\n        border-color: #f5f5f5;\n        color: #ff485c;\n    }\n\n    .cancelbtn {\n        color: #676a6c;\n        text-align: center;\n        font-size: 15px;\n        font-family: \"Open Sans\", sans-serif;\n        line-height: 1.5;\n        padding: 6px;\n    }\n}\n\n\n.editmode {\n    // margin-bottom: 30px;\n\n\n    &__list {\n\n        &row {\n            display: grid;\n            grid-template-columns: repeat(2, 1fr);\n            grid-gap: 15px;\n\n            @media #{$mq-sm} {\n                grid-template-columns: 1fr;\n            }\n\n            &--equalblocks {\n                display: flex;\n                flex-wrap: wrap;\n\n                &>.editmode__listcol {\n                    flex: 1;\n\n                    @media #{$mq-sm} {\n                        flex: none;\n                        width: 100%;\n                    }\n                }\n\n            }\n\n            &--fullblocks {\n                grid-template-columns: 1fr;\n            }\n\n            &--grid {\n                &1 {\n                    grid-template-columns: 1fr;\n                }\n\n                &3 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 3;\n                    }\n                }\n\n                &4 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 4;\n                    }\n                }\n\n                &5 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 5;\n                    }\n                }\n\n                &6 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 6;\n                    }\n                }\n\n                &7 {\n\n                    &>div:nth-child(1) {\n                        grid-row: 1 / 7;\n                    }\n                }\n            }\n        }\n\n        &cell {\n            padding: 10px 15px;\n            background-color: #EBEBEB;\n            border: 1px solid $cn-border-color;\n            border-radius: 6px;\n            height: 100%;\n\n            &--startbtn {\n                border: 1px solid $clarify-color;\n                color: $clarify-color;\n                font-weight: 600;\n                font-family: 'Open Sans';\n                font-size: 16px;\n                cursor: pointer;\n                line-height: 1;\n            }\n\n\n            @media #{$mq-sm} {\n                font-size: 13px;\n            }\n\n            h3 {\n                color: $clarify-color;\n                margin-bottom: 5px;\n\n                a,\n                i {\n                    color: inherit;\n                }\n            }\n\n            p {\n                font-size: 15px;\n                font-weight: 600;\n\n                @media #{$mq-sm} {\n                    font-size: 13px;\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n            }\n        }\n    }\n\n}\n\n.container-fluid {\n    position: relative;\n\n    .trackInfo {\n        padding: 2px 16px;\n        background-color: #6d6e71;\n        color: #fff;\n        margin-left: 40px;\n        border-radius: 5px;\n        border-bottom-left-radius: 0;\n        border-bottom-right-radius: 0;\n        font-size: 10px;\n\n        &--clr {\n            color: transparent !important;\n        }\n\n        &--inputclr {\n            color: $clarify-color;\n            font-size: 18px;\n            background: transparent;\n            margin-left: 0;\n            padding-left: 0;\n            position: absolute;\n            left: 40px;\n            top: 18px;\n            font-size: 11px;\n            background: transparent;\n            margin-left: 8px;\n        }\n    }\n}\n\n.loader-container {\n    position: absolute;\n    left: 0;\n    right: 0;\n    text-align: center;\n    top: 0;\n    bottom: 0;\n    background: rgba(236, 236, 236, .9);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: none;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    z-index: 9999999999;\n    height: 100vh;\n    margin: 0 auto;\n}\n\n.stick-challenge {\n    position: relative;\n\n    .card-body__inner {\n        min-height: auto;\n        overflow-y: auto;\n        overflow-x: hidden;\n        z-index: 9;\n        position: relative;\n        padding-top: 0;\n\n        .card-body__subtitle {\n            position: sticky;\n            top: 0;\n            z-index: 99;\n            background-color: #fff;\n            padding: 15px 0 15px 35px;\n            margin: 0;\n        }\n    }\n\n}\n\n.row {\n    &--editmodebg {\n        background-color: #fff;\n        padding: 40px 35px;\n    }\n\n    &--wbg {\n        background-color: #fff;\n    }\n}\n\n.swal2-show button.swal2-cancel.swal2-styled.wbg {\n    background-color: red !important;\n}\n\n.loader-spin {\n    background-color: hsla(0, 0%, 92.5%, .9);\n    position: fixed;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n}\n\n.loader__inner {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n\n}\n\n#Path_129 {\n    animation: blink 2s linear infinite;\n    opacity: 0;\n}\n\n#Path_130 {\n    animation: blink 2s linear infinite;\n    animation-delay: .5s;\n    opacity: 0;\n}\n\n#Path_132 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1s;\n    opacity: 0;\n}\n\n#Path_131 {\n    animation: blink 2s linear infinite;\n    animation-delay: 1.5s;\n    opacity: 0;\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0;\n    }\n\n    50% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0;\n    }\n\n}\n\n.cn-dmodal {\n    display: none;\n}","// Shared Challenge Navigator mixins, breakpoints, and variables\n// Import this at the top of each stage component SCSS\n\n@import './../../../assets/styles/variables';\n\n// CN-specific variables\n$cn-border-color: #CFDBE2;\n$cn-edit-bg: #ebebeb;\n$cn-card-bg: #f5f5f5;\n\n// Breakpoints\n$mq-pc: 'only screen and (max-width: 1200px)';\n$mq-md: 'only screen and (max-width: 991px)';\n$mq-sm: 'only screen and (max-width: 767px)';\n$mq-mobile: 'only screen and (max-width: 480px)';\n\n// Mixins\n@mixin fflex() {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n}\n\n@mixin fflex-jcc() {\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n}\n\n@mixin fflex-aic() {\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n@mixin transition-slow() {\n    -webkit-transition: all ease 0.3s;\n    -o-transition: all ease 0.3s;\n    transition: all ease 0.3s;\n}\n\n@mixin transition-none() {\n    -webkit-transition: none;\n    -o-transition: none;\n    transition: none;\n}\n\n@mixin appearance-none() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@mixin transRotate($rotate) {\n    -webkit-transform: rotate($rotate);\n    -ms-transform: rotate($rotate);\n    transform: rotate($rotate);\n}\n\n@mixin headingfont() {\n    font-family: $muso-700 !important;\n    font-weight: normal !important;\n}\n\n@mixin contentfont() {\n    font-family: $muso-300 !important;\n    font-weight: normal !important;\n}\n\n// Common element resets\nlabel {\n    font-family: 'Open Sans', sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
